import pathOr from "ramda/src/pathOr";

export const pathOrArray = pathOr([]);
